import React from 'react';

import "./header.css"
import Credits from "../../Drawer/Credits/CreditsButtonForm"
import Upgrades from "../../Drawer/Credits/UpgradeButtonForm"
import store from "./../../Common/storage.js";
import Constants from "./../../Utils/Constants/index.js"

const Header = (({ name }) => (
  <header className="c-header">
   <h3 className="text-uppercase">{name}</h3>
   <div className="c-header__item">
    {
      store.get('c_id') == 1 && <span
      className="c-button c-button--secondary text-uppercase"
      onClick={() => {Constants.navigate(Constants.accountlist)}}
    >
      Manager
    </span>
    }
    {
      store.get('user').configs.length > 1 && store.get('c_id') && <span
      className="c-button c-button--secondary text-uppercase"
      onClick={() => {
        store.removeItem('c_id')
        store.removeItem("c_id_index")
        Constants.navigate(Constants.dashboard)
      }}
    >
      Switch Company
    </span>
    }
      
     <Upgrades />
     <Credits/>
   </div>
 </header>
));

export default Header;
